export default {
    password_manteiners: process.env.VUE_APP_PASSWORD_MAINTEINERS
}